"use client";

import EventClient from "@2u-landing-pages/utils/event-client";
import { useReportWebVitals } from "next/web-vitals";

export function WebVitals() {
  useReportWebVitals((metric) => {
    let rating = metric.rating.toUpperCase();
    if (rating === "NEEDS-IMPROVEMENT") {
      rating = "NI";
    }

    EventClient.webVitals({
      metricName: metric.name,
      value: metric.delta,
      rating: rating,
    });
  });

  return null;
}
